import { AxiosError } from "axios";
import { deleteApi, getApi, patchApi, postApi, putApi } from "../CreateApi";
import {
  BodyPatchAssignmentClassroom,
  BodyPostAssignmentClassroom,
  ResponseGetAssignmentClassroom,
  ResponsePostAssignmentClassroom,
} from "./interfaceAssignmentClassroom";

export const getAssignmentClassroom = async (
  params?: any,
): Promise<ResponseGetAssignmentClassroom[]> => {
  try {
    const data = await getApi("/user/assignment-classroom", params);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as ResponseGetAssignmentClassroom[];
  }
};

export const getAssignmentClassroomId = async (
  id?: number,
): Promise<ResponseGetAssignmentClassroom> => {
  try {
    const data = await getApi(`/user/assignment-classroom/${id}`);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as ResponseGetAssignmentClassroom;
  }
};

export const postAssignmentClassroom = async (
  body: BodyPostAssignmentClassroom,
): Promise<ResponsePostAssignmentClassroom> => {
  try {
    const data = await postApi("/user/assignment-classroom", body);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as ResponsePostAssignmentClassroom;
  }
};

export const patchAssignmentClassroom = async (
  body: BodyPatchAssignmentClassroom,
  id?: number,
): Promise<ResponseGetAssignmentClassroom> => {
  try {
    const data = await patchApi(`/user/assignment-classroom/${id}`, body);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as ResponseGetAssignmentClassroom;
  }
};

export const deleteAssignmentClassroom = async (term: number): Promise<any> => {
  try {
    const data = await deleteApi(`/user/assignment-classroom/${term}`, term);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const getAssignmentClassroomBySub = async (
  sub: string,
  params?: any,
): Promise<ResponseGetAssignmentClassroom[]> => {
  try {
    const data = await getApi(`/user/${sub}/assignment-classroom`, params);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as ResponseGetAssignmentClassroom[];
  }
};

export const putAssignmentByClassroom = async (body: {
  activityClassroomId: number;
  userId: number | null;
}): Promise<any> => {
  try {
    const data = await putApi("/user/assignment-classroom/by-classroom", body);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};
